// extracted by mini-css-extract-plugin
export default {"aboutContainer":"About_aboutContainer__pXEFJ","title":"About_title__+6bic","missionStatement":"About_missionStatement__WpIM6","paragraph":"About_paragraph__x16ZE"};